import React from 'react';
import styled from 'styled-components';
import { blueColor, lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.61 32.83" {...rest}>
    <rect className="cls-1" x="8.18" y="1" width="17.43" height="22.62" rx="2.43" ry="2.43" />
    <rect className="cls-2" x="1" y="9.21" width="17.43" height="22.62" rx="2.43" ry="2.43" />
  </svg>
))`
  position: relative;
  top: -1px;

  .cls-1 {
    fill: none;
  }
  .cls-1,
  .cls-2 {
    stroke: ${({ disabled }) => (disabled ? lightGrey2Color : blueColor)};
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }
  .cls-2 {
    fill: #fff;
  }
`;
